import React from 'react';
import { useTheme, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { COMPANY_NAME } from '../../constants';
import Icon from 'assets/images/prestamo_license_icon.png';

export const FooterLicense = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const logoSize = isDesktop ? '35px' : '25px';

  return (
    <>
      <img src={Icon} style={{ maxWidth: logoSize, height: logoSize }} />
      <Typography variant={isDesktop ? 'subtitle1' : 'body1'} fontWeight={400}>
        <strong>{COMPANY_NAME}</strong> registrada en el Registro de Empresas que efectúan Operaciones Financieras o de
        Cambio de Moneda en la SBS según Resolución SBS N° 01239-2025
      </Typography>
    </>
  );
};
